import HTTP from '@/utils/http'

export const getRegionImage = async function (imageName) {
  // As getRegionImage is called before Loading component initialization
  // Loading component cannot listen `module_loading_startLoading` Event, so use HTTP.silentGet
  let { data: img } = await HTTP.silentGet(`region-static/${imageName}`, { responseType: 'blob' })
  let blob = new Blob([img], { type: img.type })
  return URL.createObjectURL(blob)
}
